/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
import { Button, message, Popconfirm } from 'antd';
import { hashHistory } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import {commentListByPC, deleteComment} from '../../service/channelFunc/comment'
import { openNotice } from 'Utils';

class CommentList extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			filterBoxVisible: false,
			rows: [],
			total: 0,
			searchObj: {
        newsId: parseInt(this.props.params.id, 10),
        content: '',
        s: 10,
        p: 1,
			}
		};
		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
    this.delComment = this.delComment.bind(this);
	}
  componentDidMount() {
    this.getData();
  }
  getData(){
    const self = this;
    const {searchObj} = this.state;
    commentListByPC(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }
	
	visibleChange () {
		this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
	}
	
	advanceReset () {
		console.log('advanceReset');
		this.setState({
			searchObj: {
				...this.state.searchObj,
        content: '',
        s: 10,
        p: 1,
			}
		})
	};

  advanceSubmit (form) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, p: 1 } }, function(){
      self.getData();
    });
  };
	
	setFilterParam (name, value) {
		console.log(name + ':\t' + value);
		if (name === 'publishTime') {
			this.setState({
				searchObj: {
					...this.state.searchObj,
					publishTimeStart: value.from,
					publishTimeEnd: value.end
				}
			})
		} else {
			this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
		}
	};

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }
  clickHandle(){
    openNotice('success', '操作成功')
  }
  goBack() {
  	hashHistory.goBack();
	}
  delComment(id) {
    deleteComment({ ids: [id] }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && this.getData();
    });
  }
	render () {
		const { filterBoxVisible, rows, total, searchObj } = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
          {
            name: 'content',
            label: '关键词',
            text: '输入关键词',
            type: 'default'
          },
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,
			rowKey: 'id',
			pageParam: {
				total,
				current: searchObj.p,//当前页码
				pageSize: searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [
				{
					title: '评论',
          dataIndex: 'content',
          width: '65%'
				}, {
					title: '评论人',
					dataIndex: 'userName'
				}, {
					title: '发布时间',
          dataIndex: 'createdDate',
          render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm') : ''
				}, {
          title: '操作',
          dataIndex: 'opt',
					render: (text, record, index) => {
          	return <span>
							<Popconfirm title="确定删除这条评论?" onConfirm={this.delComment.bind(this, record.id)} okText="是" cancelText="否">
								<a>删除</a>
							</Popconfirm>
						</span>
					}
        }
			],
			rows
		};
		return <div className="dms-body">
			<DmsTab options={['全部评论']} defaultKey={0}>
				<Button onClick={this.goBack}>返回</Button>
				<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
				<FilterBox  {...filterBoxProps}/>
			</DmsTab>
			<div className="dms-table-box">
				<TableView {...tableViewProps}/>
			</div>
		</div>
	}
}
export default CommentList;


// WEBPACK FOOTER //
// ./src/routes/channelFunc/comment.js